import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment.dev";


@Injectable({providedIn: "root"})
export class AssemblySpacingComponentService {

    public createSpacingComponentInputLamellaArea(id: string, index: number, lamellaAreaSpan: number, neededFramesConfig: any, overflowSpaceVal: boolean = false) {

        const overflowSpace= overflowSpaceVal; //[boolean]
        const spanValue= overflowSpace ? neededFramesConfig.endSpanWidth : neededFramesConfig.centerSpanWidth;
        const span = spanValue ; //[mm]
        const maxSpan= overflowSpace ? environment.FRAME_OVERFLOW_SPACE : environment.FRAME_MAX_SPAN //[mm]
        const minSpan= overflowSpace ? 0 : environment.FRAME_MIN_SPAN //[mm]
        const frameSpacingConfig = neededFramesConfig;
        const reinforced = false;

        return {
            id,
            index,
            span,
            lamellaAreaSpan,
            overflowSpace,
            frameSpacingConfig,
            reinforced,
            maxSpan,
            minSpan
        };

    }

    public createSpacingComponentInputFromFramePositionsLamellaArea(id: string, index: number, lamellaAreaSpan: number, framePositions: any[], neededFramesConfig: any, overflowSpaceVal: boolean = false) {
        const framePositionsWithIndexes = framePositions.map((f: any, idx: number) => ({...f, index: ( 1 + ( idx * 2 ))}))
        const previousFrame = framePositionsWithIndexes.find((item: any) => item.index === index - 1 );
        const nextFrame = framePositionsWithIndexes.find((item: any) => item.index === index + 1 );
        const reinforced = index > 0 && index < framePositions.length * 2 ? previousFrame?.reinforced || nextFrame?.reinforced : false; //[boolean]
        const overflowSpace= overflowSpaceVal; //[boolean]
        if(!previousFrame && !nextFrame) { throw new Error('Frame positions not found on creating frame Spacing component Input; both next and previous frame values are undefined!') }
        const span= !previousFrame ? nextFrame?.position : !nextFrame ? lamellaAreaSpan - previousFrame?.position : nextFrame.position! - previousFrame.position!;
        const maxSpan= overflowSpace ? environment.FRAME_OVERFLOW_SPACE : environment.FRAME_MAX_SPAN //[mm]
        const minSpan= overflowSpace ? 0 : environment.FRAME_MIN_SPAN //[mm]
        const frameSpacingConfig = neededFramesConfig;

        return {
            id,
            index,
            span,
            lamellaAreaSpan,
            overflowSpace,
            frameSpacingConfig,
            reinforced,
            maxSpan,
            minSpan
        };

    }

}